"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
// Input
var UploadFile_vue_1 = __importDefault(require("./Components/Input/UploadFile.vue"));
var TextMultiline_vue_1 = __importDefault(require("./Components/Input/TextMultiline.vue"));
var TextInput_vue_1 = __importDefault(require("./Components/Input/TextInput.vue"));
var HiddenInput_vue_1 = __importDefault(require("./Components/Input/HiddenInput.vue"));
var Number_vue_1 = __importDefault(require("./Components/Input/Number.vue"));
var DatepickerDatetime_vue_1 = __importDefault(require("./Components/Input/DatepickerDatetime.vue"));
var DatepickerDate_vue_1 = __importDefault(require("./Components/Input/DatepickerDate.vue"));
var DatepickerTime_vue_1 = __importDefault(require("./Components/Input/DatepickerTime.vue"));
var SelectCustom_vue_1 = __importDefault(require("./Components/Input/SelectCustom.vue"));
var SelectIntervenant_vue_1 = __importDefault(require("./Components/Input/SelectIntervenant.vue"));
var OzSelectActe_vue_1 = __importDefault(require("./Components/Input/OzSelectActe.vue"));
var CheckBox_vue_1 = __importDefault(require("./Components/Input/CheckBox.vue"));
var RadioButton_vue_1 = __importDefault(require("./Components/Input/RadioButton.vue"));
var MultipleInput_vue_1 = __importDefault(require("./Components/Input/MultipleInput.vue"));
var AffectationTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/AffectationTransformateur.vue"));
var AffectationsTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/AffectationsTransformateur.vue"));
var DeposeTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/DeposeTransformateur.vue"));
var DeposesTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/DeposesTransformateur.vue"));
var PoseTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/PoseTransformateur.vue"));
var ReceptionTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/ReceptionTransformateur.vue"));
var ReceptionsTransformateur_vue_1 = __importDefault(require("./Components/SpecificComponents/ReceptionsTransformateur.vue"));
// Output
var TextOutput_vue_1 = __importDefault(require("./Components/Output/TextOutput.vue"));
var FileListOutput_vue_1 = __importDefault(require("./Components/Output/FileListOutput.vue"));
var Iterations_vue_1 = __importDefault(require("./Components/Output/Iterations.vue"));
var OzConceptTable_vue_1 = __importDefault(require("./Components/Output/OzConceptTable.vue"));
// Action
var Action_vue_1 = __importDefault(require("./Components/Action/Action.vue"));
var OzDownloadFiles_vue_1 = __importDefault(require("./Components/Action/OzDownloadFiles.vue"));
// Layout
var Row_vue_1 = __importDefault(require("./Components/Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("./Components/Layout/Column.vue"));
// VueJS
var Task = /** @class */function () {
    function Task($el) {
        this.$el = $el;
    }
    Task.prototype.loadTaskView = function (model) {
        var vue = new vue_1.default({
            el: this.$el.get(0),
            data: model,
            components: {
                // Input
                "upload-file": UploadFile_vue_1.default,
                "text-multiline": TextMultiline_vue_1.default,
                "text-input": TextInput_vue_1.default,
                "hidden-input": HiddenInput_vue_1.default,
                "number-input": Number_vue_1.default,
                "datepicker-datetime": DatepickerDatetime_vue_1.default,
                "datepicker-date": DatepickerDate_vue_1.default,
                "datepicker-time": DatepickerTime_vue_1.default,
                "select-custom": SelectCustom_vue_1.default,
                "select-intervenant": SelectIntervenant_vue_1.default,
                "oz-select-acte": OzSelectActe_vue_1.default,
                "check-box": CheckBox_vue_1.default,
                "radio-button": RadioButton_vue_1.default,
                "multiple-input": MultipleInput_vue_1.default,
                "affectation-transformateur": AffectationTransformateur_vue_1.default,
                "affectations-transformateur": AffectationsTransformateur_vue_1.default,
                "depose-transformateur": DeposeTransformateur_vue_1.default,
                "deposes-transformateur": DeposesTransformateur_vue_1.default,
                "pose-transformateur": PoseTransformateur_vue_1.default,
                "reception-transformateur": ReceptionTransformateur_vue_1.default,
                "receptions-transformateur": ReceptionsTransformateur_vue_1.default,
                // Output
                "file-list": FileListOutput_vue_1.default,
                "text-output": TextOutput_vue_1.default,
                "oz-iterations": Iterations_vue_1.default,
                "oz-concept-table": OzConceptTable_vue_1.default,
                // Action
                "action": Action_vue_1.default,
                "oz-download-files": OzDownloadFiles_vue_1.default,
                // Layout
                "he-row": Row_vue_1.default,
                "he-column": Column_vue_1.default
            },
            methods: {
                evalPredicate: function evalPredicate(leftval, operator, rightVal) {
                    switch (operator.toLowerCase()) {
                        case "=":
                            return leftval == rightVal;
                        case ">=":
                            return leftval >= rightVal;
                        case ">":
                            return leftval > rightVal;
                        case "<=":
                            return leftval <= rightVal;
                        case "<":
                            return leftval < rightVal;
                        case "!=":
                            return leftval != rightVal;
                        case "notempty":
                            return leftval != "";
                        case "contains":
                            return leftval.indexOf(rightVal) > -1;
                        case "arraycontains":
                            try {
                                var array = JSON.parse(leftval);
                                // On n'utilise pas indexOf car on souhaite pouvoir comparer des string et des number
                                return array.find(function (_) {
                                    return _ == rightVal;
                                }) != null;
                            } catch (_a) {
                                return false;
                            }
                    }
                    return false;
                },
                getChildren: function getChildren(component) {
                    var _this = this;
                    var children = [];
                    if (component.$children && component.$children.length > 0) {
                        component.$children.forEach(function (item) {
                            children.push.apply(children, [item].concat(_this.getChildren(item)));
                        });
                    }
                    return children;
                }
            },
            mounted: function mounted() {
                var _this = this;
                // Déclaration de l'évènement de changement des predicats
                this.$on("predicate-change", function (condition) {
                    // Nom de l'input qui vient d'être modifié
                    var key = condition.name;
                    // Valeur de l'input qui vient d'être modifié
                    var value = condition.value || "";
                    // On récupère les prédicats correspondant à notre input
                    var predicates = (_this.$data.predicates || []).filter(function (item) {
                        return item.componentName === key;
                    });
                    // Si on a pas de prédicats, on se casse !
                    if (predicates.length === 0) {
                        return;
                    }
                    var allComponents = _this.getChildren(_this);
                    var _loop_1 = function _loop_1(predicate) {
                        // On récupère tous les enfants concernés par ce prédicat
                        var children = allComponents.filter(function (item) {
                            if (!item.getPredicateResult) {
                                return false;
                            }
                            var p = item.getPredicateResult();
                            return predicate.name in p;
                        });
                        // Si on a pas d'enfats, on se casse !
                        if (children.length === 0) {
                            return "continue";
                        }
                        var predicateResult = _this.evalPredicate(value, predicate.operator, predicate.value);
                        // On parcours les components enfants pour voir s'ils sont concernés par ce prédicat
                        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                            var child = children_1[_i];
                            // Si on est là, on met à jour le boolean correspondant au predicat du component
                            if (child.setPredicateResult) {
                                child.setPredicateResult(predicate.name, predicateResult);
                            }
                        }
                    };
                    // On parcours tous les predicats
                    for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
                        var predicate = predicates_1[_i];
                        _loop_1(predicate);
                    }
                });
                // Traitement des prédicats sur les SourceType / SourceTarget
                var predicates = (this.$data.predicates || []).filter(function (item) {
                    return item.sourceType && item.sourceTarget;
                });
                // Calcul des résultats
                predicates.forEach(function (p) {
                    var value = _this.$data.dataStore[p.sourceType.toLowerCase() + "_" + p.sourceTarget];
                    p.result = _this.evalPredicate(value, p.operator, p.value);
                });
                // Déclenchement des prédicats
                this.getChildren(this).forEach(function (child) {
                    // Les prédicats sur les datastore
                    try {
                        predicates.forEach(function (p) {
                            if (child.setPredicateResult) {
                                child.setPredicateResult(p.name, p.result);
                            }
                        });
                    } catch (e) {}
                    // Ignore

                    // Puis ceux des champs
                    try {
                        child.predicateChange();
                    } catch (e) {}
                    // Ignore

                    // Puis ceux des champs
                    try {
                        child.formulaChanged();
                    } catch (e) {
                        // Ignore
                    }
                });
            }
        });
    };
    Task.preview = function ($form, source) {
        var form = $form.get(0);
        var $popupForm = $("<form method='post' target='TaskPreview' action='/Admin/Workflows/PreviewTask'></form>").hide().appendTo($("body"));
        var $html = $(form.HtmlContent);
        var hcm = $html.data("emmet-editor");
        if (hcm) {
            hcm.save();
        }
        var $json = $(form.JsonContent);
        var jcm = $json.data("emmet-editor");
        if (jcm) {
            jcm.save();
        }
        $("<input name='TypeRender' />").val($form.find("select.ddl-render-type").val()).appendTo($popupForm);
        $("<input name='HtmlContent' />").val($html.val()).appendTo($popupForm);
        $("<input name='JsonContent' />").val($json.val()).appendTo($popupForm);
        $("<input name='Source' />").val(source).appendTo($popupForm);
        window.open("", "TaskPreview", "width=900, height=600");
        $popupForm.get(0).submit();
        $popupForm.remove();
    };
    return Task;
}();
exports.Task = Task;
/**
 * Plugin jQuery
 *
 * @param model
 * @param route
 * @returns {}
 */
$.fn.initWorkflowTask = function (model) {
    var $root = $(this);
    var $form = $root.find("form");
    model.affaireId = $form.data("affaireId");
    model.bonCommandeId = $form.data("bonCommandeId");
    model.entrepriseId = $form.data("entrepriseId");
    model.taskId = $form.data("taskId");
    model.inputIdentifier = $form.data("inputIdentifier");
    model.readOnly = $form.hasClass("read-only");
    model.canDelete = $form.data("canDelete");
    var t = new Task($root);
    t.loadTaskView(model);
};
$.fn.previewTask = function (source) {
    Task.preview($(this), source);
};
$.fn.initDocumentedConfiguration = function () {
    var $type = $(this);
    var loadDoc = function loadDoc($select) {
        var $selected = $select.find("option:selected");
        var $doc = $($type.data("target-doc"));
        var doc = $selected.data("doc");
        var html = "";
        if (doc) {
            html = "<ul>" + $.map(Object.keys(doc), function (k) {
                return "<li><strong>" + k + "</strong> : " + (doc[k] || "<em>Non documenté</em>") + "</li>";
            }).join("") + "</ul>";
        }
        $doc.html(html);
    };
    $type.on("change", function () {
        var $select = $(this);
        var $config = $($type.data("target-configuration"));
        var $selected = $select.find("option:selected");
        loadDoc($select);
        if ($config.val() == "" || confirm("Le contenu de la configuration actuelle va être remplacé, souhaitez-vous continuer ?")) {
            var json = $selected.attr("data-json");
            $config.data("emmet-editor").setValue(json);
            $config.val(json);
        }
    });
    loadDoc($type);
};
$.fn.initComponentInsert = function () {
    var $select = $(this);
    var $json = $($select.data("target-json"));
    var editor = $json.data("emmet-editor");
    var doc = editor.getDoc();
    var $tabs = $(".switch-html-doc");
    $select.on("change", function () {
        var json = $select.val();
        var select = doc.listSelections();
        var colOffset = select[0].anchor.ch;
        var pad = Array(colOffset).join(" ");
        json = json.split(/[\r\n]+/).join("\n" + pad);
        doc.replaceSelection(json);
        $json.val(doc.getValue());
        $select.val("");
    });
    var $divDoc = $("div[data-content-doc]"),
        docs = $divDoc.data("content-doc"),
        html = "";
    $.map(Object.keys(docs), function (k) {
        html = html + ("<h5 class=\"docs-title cursor-hand\" style=\"font-weight:bold;text-decoration:underline;\"><i class=\"fa fa-fw fa-play mr-2\"></i>" + k + " :</h5>");
        var compos = docs[k];
        $.map(Object.keys(compos), function (c) {
            html = html + ("<h6 class=\"cursor-hand ml-4 d-none\" style=\"font-weight:bold;\" data-categorie=\"" + k.replace(/\s*:\s*/, "") + "\"><i class=\"fa fa-fw fa-play mr-2\"></i>" + c + "</h6>");
            var props = JSON.parse(compos[c]);
            html = html + ("<ul data-categorie=\"" + k.replace(/\s*:\s*/, "") + "\" class=\"ml-5 d-none\">") + $.map(Object.keys(props), function (p) {
                return "<li><strong>" + p + "</strong> : " + (props[p] || "<em>Non documenté</em>") + "</li>";
            }).join("") + "</ul>";
        });
    });
    $divDoc.html(html);
    $(document).on("click", ".docs-title", function () {
        var $this = $(this),
            $i = $this.find("i"),
            $h6 = $("h6[data-categorie=" + $this.text().replace(/\s*:\s*/, "") + "]");
        $i.toggleClass("fa-rotate-90");
        if (!$i.hasClass("fa-rotate-90")) {
            $.map($h6, function (h6) {
                var $h6Elem = $(h6);
                if (!$h6Elem.hasClass("d-none") && !$h6Elem.next().hasClass("d-none")) {
                    $h6Elem.next().toggleClass("d-none");
                    $h6Elem.find("i").toggleClass("fa-rotate-90");
                }
            });
        }
        $h6.toggleClass("d-none");
    }).on("click", "h6[data-categorie]", function () {
        var $this = $(this);
        $this.next().toggleClass("d-none");
        $this.find("i").toggleClass("fa-rotate-90");
    });
    $tabs.on("click", function () {
        var $this = $(this),
            $parent = $this.parent();
        $tabs.toggleClass("btn-secondary").toggleClass("btn-outline-secondary");
        $parent.parent().find("div.form-group , button:not(.switch-html-doc)").toggleClass("d-none");
        $(this).trigger("blur");
    });
};
// Initialisation de l'évènement de submit des formulaires de task data
$(function () {
    var $body = $("body");
    // Empêche le submit sans passer par un bouton
    $body.on("submit", ".task-data-form", function (e) {
        e.preventDefault();
    });
    $body.on("click", ".task-data-form button.action-button[value]", function (e) {
        e.preventDefault();
        var $button = $(this);
        var $form = $button.parents("form");
        var form = $form.get(0);
        var $message = $button.next(".message").html("");
        var alertClass = "alert p-1 px-3 m-0 mx-1";
        var $containerElement = $form;
        $button.attr("disabled", "disabled");
        if ($button.attr("formaction")) {
            $form.attr("action", $button.attr("formaction"));
            var scope = $button.data("mandatory-fields-scope");
            if (scope) {
                $containerElement = $button.parents(scope);
            }
        }
        // Vidage des messages existants
        $form.find(".message").html("");
        // Vérification des champs obligatoires
        var mandatoryFields = $button.data("mandatory-fields");
        var requiredFields = [];
        if (mandatoryFields) {
            $.each(mandatoryFields.split(/\s*,\s*/), function (i, f) {
                var $el = $("[name='" + f + "']", $containerElement);
                requiredFields.push($el[0]);
            });
        }
        $.each($("[required=required]", $containerElement), function (i, f) {
            if ($.inArray(f, requiredFields) === -1) {
                requiredFields.push(f);
            }
        });
        // On supprime l'indicateur d'erreur
        $form.find(".form-group.error").removeClass("error");
        if (requiredFields.length > 0) {
            var emptyFields = [];
            $.each(requiredFields, function (i, f) {
                var $f = $(f);
                if ($f.is(":radio")) {
                    $f = $("input:radio[name=" + $f.attr("name") + "]");
                }
                if ($f.length === 0) {
                    console.error("Champ non retrouvé : " + f);
                    return;
                }
                if ($f.val() == "" || $f.data("serialized") && $f.val() === "[]" || ($f.is(":radio") || $f.is(":checkbox")) && !$f.is(":checked") || $f.val() == null) {
                    emptyFields.push($f);
                    $f.parents(".form-group").addClass("error");
                    if (emptyFields.length === 1) {
                        $f.focus();
                    }
                }
            });
            if (emptyFields.length > 0) {
                var msg = emptyFields.length === 1 ? "<div>Un champ obligatoire n'a pas \xE9t\xE9 saisi</div>" : "<div>" + emptyFields.length + " champs obligatoires n'ont pas \xE9t\xE9 saisis</div>";
                $message.html("").append($(msg).addClass(alertClass + " alert-warning"));
                $button.removeAttr("disabled");
                return;
            }
        }
        var submitTaskData = function submitTaskData() {
            var ignoreFields = $button.data("ignore-fields"),
                data = $form.intuitiveSerializeObject();
            delete data["__RequestVerificationToken"];
            if (ignoreFields && ignoreFields.length > 0) {
                var message = "";
                $.each(ignoreFields.split(/\s*,\s*/), function (i, f) {
                    delete data[f];
                    var $f = $(form.elements[f]),
                        isCbOrRad = $f.is(":radio") || $f.is(":checkbox");
                    if (isCbOrRad && $f.is(":checked") || !isCbOrRad && $f.val() && $f.val() !== "[]") {
                        var $formGroup = $f.parents(".form-group:first"),
                            $label = $f.is(":checkbox") ? $f.prev() : $formGroup.find("label:first"),
                            messageItem = undefined;
                        if (!$label || $label.length === 0 || !$label.val()) {
                            $label = $formGroup.prev();
                        }
                        if ($label && ($label.val() || $label.text())) {
                            messageItem = $label.val() || $label.text();
                        } else {
                            var $next = $f.next("label:first");
                            messageItem = $next.length !== 0 && $next.val() ? $next.val() : undefined;
                        }
                        if (messageItem) {
                            message = message + ("\n - " + messageItem.replace(/\s*:\s*/g, ""));
                        }
                    }
                });
                if (message && message.length > 0 && !confirm("Les champs suivants ne seront pas enregistr\xE9s si vous confirmez votre action :\n " + message + " \n\nConfirmez-vous cette action ?")) {
                    $button.removeAttr("disabled");
                    return false;
                }
            }
            // Construction du FormData correspondant au AffaireTaskDataExecuteViewModel
            var fd = new FormData();
            // Données du form
            fd.append("SerializedData", JSON.stringify(data));
            // Props du form
            fd.append("TaskId", $form.data("taskId"));
            fd.append("AffaireId", $form.data("affaireId"));
            fd.append("BonCommandeId", $form.data("bonCommandeId"));
            fd.append("InputIdentifier", $form.data("inputIdentifier"));
            // Props du bouton
            fd.append("ActionId", $button.attr("value"));
            if ($button.data("index-item") != undefined && $button.data("index-item") != null) {
                fd.append("IndexItem", $button.data("index-item"));
            }
            if ($button.data("action-transfo") != undefined && $button.data("action-transfo") != null) {
                fd.append("ActionTransfo", $button.data("action-transfo"));
            }
            if ($button.data("bc-transfo-id") != undefined && $button.data("bc-transfo-id") != null) {
                fd.append("BonCommandeTransfoId", $button.data("bc-transfo-id"));
            }
            fd.append("__RequestVerificationToken", $form[0]["__RequestVerificationToken"].value);
            $.ajax({
                url: $form.attr("action"),
                method: "post",
                processData: false,
                contentType: false,
                data: fd
            }).done(function (result) {
                if (result.message) {
                    $message.html("").append($("<div>" + result.message + "</div>").addClass(alertClass + " alert-warning"));
                    $button.removeAttr("disabled");
                    return false;
                }
                switch (result.onSubmit) {
                    default:
                    case "reload":
                        document.location.reload();
                        break;
                    case "goto":
                        document.location.assign(result.url);
                        break;
                }
            }).fail(function () {
                $message.html("").append($("<div>Une erreur s'est produite</div>").addClass(alertClass + " alert-warning"));
                $button.removeAttr("disabled");
            });
        };
        // Vérification des champs d'upload
        var $uploadInputs = $form.find(".orezo-file-input");
        var vueUploadInputs = $uploadInputs.toArray().map(function (e) {
            return e["__vue__"];
        });
        // Validation des données (fileType, etc)
        var invalidUploads = vueUploadInputs.filter(function (_) {
            return !_.validateBeforeSubmit();
        });
        if (invalidUploads.length > 0) {
            var msg = invalidUploads.length === 1 ? "<div>Un champ de d\xE9p\xF4t de fichier n'est pas complet</div>" : "<div>" + emptyFields.length + " champs de d\xE9p\xF4t de fichier ne sont pas complets</div>";
            $message.html("").append($(msg).addClass(alertClass + " alert-warning"));
            $button.removeAttr("disabled");
            return;
        }
        // Indicateur de chargement
        $message.append($('<i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>'));
        // Déclenchement des upload
        var vueUploadInputsWithNewFiles = vueUploadInputs.filter(function (_) {
            return _.getValidInputFiles().length > 0;
        });
        if (vueUploadInputsWithNewFiles.length > 0) {
            var remainingUploads_1 = vueUploadInputsWithNewFiles.length;
            // On décremente jusqu'à ce que tout soit uploadé
            $uploadInputs.on("vue-upload:end", function () {
                remainingUploads_1--;
                if (remainingUploads_1 === 0) {
                    $(window).off("beforeunload");
                    submitTaskData();
                }
            });
            // On bloque la sortie de la page
            $(window).on("beforeunload", function (e) {
                // Message plus vraiment supporté par aucun navigateur, mais au cas où ...
                var message = "Veuillez patienter jusqu'à la fin de l'envoi des fichiers";
                if (e && e.originalEvent) {
                    //@ts-ignore
                    e.originalEvent.returnValue = message;
                }
                return message;
            });
            vueUploadInputs.forEach(function (_) {
                return _.startRealUpload.apply(_);
            });
        } else {
            submitTaskData();
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Workflow/index.ts
// module id = 535
// module chunks = 0